import { BaseEntity } from '../../../core/BaseEntity';

export class EquipmentItem extends BaseEntity {
  EquipmentId: string;
  UserId: string;
  Make: string;
  Model: string;
  Notes: string;
}
